import { Controller } from "@hotwired/stimulus"
import initials from "initials"

export default class extends Controller {
  static targets = ["initials"]
  static values = {
    name: { type: String, default: "" }
  }
  connect () {
    this.initialsTarget.innerText = initials(this.nameValue)
  }
}
